function uploadClientFile() {
    var uploadField = $('.additional-cv');
    if( uploadField.length ){

        var inputFile = $('.upload-cv-input'),
            btn = $('.input-upload-block'),
            file_name_txt = $('.file-name'),
            deff_name_txt = file_name_txt.data('default');

        file_name_txt.html(deff_name_txt);

        inputFile.on('click', function (e) {
            e.stopPropagation();
        });

        btn.each(function () {
            $(this).on('click', function () {
                console.log('click');
                inputFile = $(this).find('.upload-cv-input');
                inputFile.click();
            })
        });

        inputFile.each(function () {
            $(this).on('change', function () {
                $(this).next('.file-name').html( $(this).val() );
            })
        });
    }
}

function showJobModal() {
    if ($('#is-show-success-modal').val()) {
        $('#form-modal-success').modal('show');
    }
}

function acceptJobPolicy(){
    let acceptStatus = $('.policy_agreement');
    if(acceptStatus){
        let submitButtons = $('.vacancies-sections .btn-bar .button-wrap .btn');
        acceptStatus.on('change', function (){
            if( $(this).is(':checked') ){
                submitButtons.removeAttr('disabled');

                acceptStatus.each(function (){
                    $(this).prop('checked', true);
                })
            } else {
                submitButtons.attr('disabled', true);

                acceptStatus.each(function (){
                    //console.log($(this), $(this).is(':checked') )
                    $(this).prop('checked', false);
                })
            }
        });
    }
}


uploadClientFile();
showJobModal();
acceptJobPolicy();
